import { unsafeCSS } from 'lit';
import imagePickerCss from './image-picker-styles.css?inline';

/**
 * Thin barrel over image-picker-styles.css.
 *
 * Kept as a module rather than importing the stylesheet directly because
 * index.ts re-exports this file with `export *`, and a `?inline` import cannot
 * be re-exported as a named binding.
 */
export const styles = unsafeCSS(imagePickerCss);
